module.exports = __webpack_public_path__ + "media/teacher.006c0aea.mp3";